import { InputGroup, FormControl, Form, Button } from 'react-bootstrap';
import { Condition } from '@/modules/trade-rule-builder/model/trade-rule-builder';
import type { SeriesOption } from '@/modules/trade-rule-builder/model/trade-rule-builder';

interface Props {
  condition: Condition;
  onUpdate: <K extends keyof Condition>(key: K, value: Condition[K]) => void;
  onDelete?: () => void;
  seriesOptions?: SeriesOption[];
}

// Helper to check if a string is a valid number input (empty, '-', or valid number)
function isAllowedNumberInput(val: string) {
  return /^-?\d*(\.\d*)?$/.test(val);
}

export default function ConditionEditor(props: Props) {
  const { condition, onUpdate, onDelete, seriesOptions = [] } = props;

  return (
    <InputGroup className="mb-2" size="sm">
      <Form.Select
        value={condition.seriesId || ''}
        onChange={e => onUpdate('seriesId', e.target.value)}
        style={{
          border: '1px solid #5c5c5cff',
          minWidth: 120,
          fontSize: '0.9em',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          paddingRight: 10,
        }}
      >
        <option value="">Select series...</option>
        {seriesOptions.map((opt: SeriesOption) => (
          <option key={opt.dataSeriesId} value={opt.dataSeriesId}>
            {opt.display}
          </option>
        ))}
      </Form.Select>
      <Form.Select
        value={condition.comparator}
        onChange={e => onUpdate('comparator', e.target.value)}
        style={{
          border: '1px solid #5c5c5cff',
          maxWidth: 60,
          fontSize: '0.9em',
          paddingLeft: 4,
          paddingRight: 4,
        }}
      >
        <option value=">">&gt;</option>
        <option value="<">&lt;</option>
        <option value=">=">≥</option>
        <option value="<=">≤</option>
        <option value="=">=</option>
      </Form.Select>
      <FormControl
        type="text"
        inputMode="decimal"
        placeholder="#"
        value={typeof condition.value === 'string' ? condition.value : String(condition.value)}
        onChange={e => {
          const val = e.target.value;
          if (isAllowedNumberInput(val)) {
            if (val === '' || val === '-') {
              onUpdate('value', val as unknown as Condition['value']);
            } else {
              onUpdate('value', parseFloat(val) as Condition['value']);
            }
          }
        }}
        style={{ maxWidth: 120, border: '1px solid #5c5c5cff' }}
      />
      {onDelete && (
        <Button variant="outline-danger" size="sm" onClick={onDelete}>
          &times;
        </Button>
      )}
    </InputGroup>
  );
}
